import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnFilterClickAdjustment(props) {
  let current = useDataValue({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (current.length === 0) {
      change(['adjustment'])
      return
    }

    if (current.includes('adjustment')) {
      let newSelected = current.filter(item => item !== 'adjustment')
      change(newSelected)
    } else {
      change([...current, 'adjustment'])
    }
  }
}

export function getCount(transactions, type) {
  return transactions.filter(item => item.type === type).length
}
